import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;

function api(path) {
  const token = localStorage.getItem('token');
  return fetch(`${API_BASE_URL}${path}`, {
    headers: { Authorization: `Bearer ${token}` }
  }).then(r => r.json());
}

export default function QRPrintPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [housing, setHousing] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api(`/housings/${id}`)
      .then(h => { setHousing(h); setLoading(false); })
      .catch(() => setLoading(false));
  }, [id]);

  const qrSrc = housing ? `${API_BASE_URL}/housings/qr-image/${housing.qr_uuid}` : null;

  if (loading) return <div style={{ padding: 32, fontFamily: 'sans-serif' }}>Loading...</div>;
  if (!housing) return <div style={{ padding: 32, fontFamily: 'sans-serif' }}>Housing not found.</div>;

  return (
    <>
      {/* Screen controls — hidden when printing */}
      <div className="no-print" style={{ backgroundColor: '#2d3748', color: 'white', padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ backgroundColor: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>← Back</button>
        <span style={{ flex: 1, fontWeight: 'bold' }}>QR Label — {housing.label || 'Housing'}</span>
        <button onClick={() => window.print()} style={{ backgroundColor: '#3182ce', border: 'none', color: 'white', padding: '8px 18px', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 'bold' }}>
          Print
        </button>
      </div>

      {/* Print label */}
      <div className="print-label" style={{
        fontFamily: 'sans-serif',
        padding: 32,
        maxWidth: 420,
        margin: '40px auto',
        border: '2px solid #2d3748',
        borderRadius: 12,
        textAlign: 'center',
        backgroundColor: 'white',
      }}>
        {/* QR code — fetched from backend as PNG */}
        <img
          src={qrSrc}
          alt="QR Code"
          style={{ width: 220, height: 220, display: 'block', margin: '0 auto 20px' }}
          onError={e => { e.target.style.display = 'none'; }}
        />

        <div style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 6 }}>
          {housing.label || 'Fiber Housing'}
        </div>

        <div style={{ fontSize: 14, color: '#555', marginBottom: 16 }}>
          {housing.chassis_type}
          {housing.manufacturer ? ` · ${housing.manufacturer}` : ''}
          {housing.model ? ` ${housing.model}` : ''}
        </div>

        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 14, fontSize: 12, color: '#888', wordBreak: 'break-all' }}>
          {housing.qr_uuid}
        </div>
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          .print-label {
            margin: 0 auto !important;
            border: 2px solid #000 !important;
            box-shadow: none !important;
          }
        }
      `}</style>
    </>
  );
}
